import { gsap } from 'gsap'

import Common from 'js/_core/Common'
import { roundEx } from 'js/utils/Maths'

import ViewController from 'js/app/controllers/ViewController'
import LottieAnimation from 'js/modules/_base/effects/lottie/LottieAnimation'
import HomeFadeSlideshow from 'js/modules/projects/ui/HomeFadeSlideshow'
import CompanyMarqueeSlideshow from 'js/modules/projects/effects/CompanyMarqueeSlideshow'

export default class BusinessSingleViewController extends ViewController {
  constructor(content) {
    super(content)
    if (this.debug) {
      this.pageName = '[businessSingle]'
    }

    // ページ別のコンテンツ(html)はここからアクセスできます
    this.$content = content

    this.isInViwAnimationSceneAG = false

    this.fadeSlideshowInstances = []

    if (!Common.detection.useWebgl) {
      this.$slideshowWraps.forEach(($slideshowWrap, i) => {
        this.fadeSlideshowInstances[i] = new HomeFadeSlideshow({
          $wrapper: $slideshowWrap,
        })
        this.fadeSlideshowInstances[i].init()
        this.fadeSlideshowInstances[i].run()
      })
    }
  }

  async willLoad() {
    await super.willLoad()
  }

  async didLoad() {
    await super.didLoad()
  }

  async beforeEnter() {
    await super.beforeEnter()
    this._setAnimationScenes()
  }

  async enter() {
    this.addHandlers()
    await super.enter()
    this._addObservers()
    this._setLayout()
    if (Common.webgl) {
      gsap.delayedCall(0.2, () => {
        Common.webgl.fvAnimation({
          pageId: this.id,
        })
      })
    }
  }

  async afterEnter() {
    await super.afterEnter()
  }

  async beforeLeave() {
    await super.beforeLeave()
    this._removeObservers()
    this.removeHandlers()
  }

  async leave() {
    await super.leave()
  }

  async afterLeave() {
    await super.afterLeave()
  }

  _set$() {
    super._set$()
    this.$animationSceneAG = this.$content.querySelector('[data-animation-scene="company_ag"]')
    this.$slideshowWraps = this.$content.querySelectorAll('[data-slideshow-wrap="fade"]') || []
    this.$businessSects = this.$content.querySelectorAll('[data-layut="company-business-sect"]')
  }

  addHandlers() {
    super.addHandlers()
    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, 'BusinessSingleViewControllerResize')
    }
  }

  removeHandlers() {
    super.removeHandlers()
    if (Common.resize) {
      Common.resize.removeHandler('BusinessSingleViewControllerResize')
    }
  }

  _addObservers() {
    if (this.$animationSceneAG) {
      Common.iom.add(this.$animationSceneAG, () => {
        if (!this.isInViwAnimationSceneAG) {
          this.isInViwAnimationSceneAG = true
          if (this.animationSceneAG) {
            this.animationSceneAG.enterAnimation()
          }
        }
      })
    }
  }

  _removeObservers() {
    if (this.$animationSceneAG) {
      Common.iom.remove(this.$animationSceneAG)
      // this.isInViwAnimationSceneAG = false
    }
  }

  _setAnimationScenes() {
    if (this.$animationSceneAG) {
      this.animationSceneAG = new LottieAnimation({
        $target: this.$animationSceneAG,
        animationOption: {
          renderer: 'canvas',
          loop: false,
          autoplay: false,
        },
      })
      this.animationSceneAG.init()
    }
  }

  _setLayout() {
    if (Common.detection.isMobileLayout) {
      this.$businessSects.forEach(($sect) => {
        const $head = $sect.querySelector('[data-layout="company-business-head"]')
        const $mainSectLeft = $sect.querySelector('[data-layout="company_business_sect_main_left"]')

        if ($head) {
          const headHeight = roundEx($head.offsetHeight, 100)
          $mainSectLeft.style.top = headHeight + 'px'
        }
      })
    }
  }

  onResize() {
    super.onResize()
    this._setLayout()
  }
}